
import { makeStyles, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import IniciaisLetras from "./iniciaisLetras";


const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center',
        width: '16%',
        minWidth: 220,
        height: 150,
        // lineHeight: 1,
        // fontSize: 16, 

        border: '1px solid #85287e',
        borderRadius: 10,
        transition: '.5s',
        '&:hover': { background: '#85287d8a', transform: 'scale(1.1)', border: '1px solid #000', },

        [theme.breakpoints.down('xs')]: {
            minWidth: 135,
            width: '45%',
            height: 180,
        },
    },
}))

type cardServicesProps = {
    icone?: string;
    nomeService: string;
    link: string;
    status: boolean;
}

export default function CardServices({ icone, nomeService, link, status }: cardServicesProps) {
    const classes = useStyles()

    return (
        <CardActionArea disabled={!status} className={classes.root} >
            <Link style={{ textDecoration: 'none' }} to={link}>
                <CardContent>
                    {icone ?
                        <div style={{ height: 50 }}>
                            <img src={icone} alt={''} style={{ height: 75, margin: 'auto' }} />
                        </div>
                        :
                        <Typography align="center" color="textSecondary" variant="h3" >
                            <IniciaisLetras frase={nomeService} />
                        </Typography>
                    }
                </CardContent>

                <CardContent >
                    <Typography color="textPrimary" variant="body1" style={{ fontSize: '14px', textAlign: "center" }}>
                        {nomeService}
                    </Typography>
                </CardContent>
            </Link>
        </CardActionArea>
    )
} 